import Dashboard from "./employee/Dashboard";

const Employee = {
    Dashboard
};

export default Employee;